
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('reservas');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/984c61fb1d0e1b164c767d77ce684762.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 md:py-32 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 drop-shadow-2xl leading-tight">
          <strong>{t('heroMainTitle')}</strong>
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-white mb-6 sm:mb-8 max-w-4xl mx-auto drop-shadow-lg font-semibold px-2 sm:px-4">
          <strong>{t('heroServiceTitle')}</strong>
        </p>
        
        <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white/95 mb-8 sm:mb-10 md:mb-12 max-w-3xl mx-auto drop-shadow-lg px-2 sm:px-4 leading-relaxed">
          {t('heroServiceSubtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-5 justify-center items-center px-2 sm:px-4 mb-10 sm:mb-12 md:mb-16">
          <button
            onClick={scrollToBooking}
            className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-6 sm:px-8 md:px-10 lg:px-12 py-3.5 sm:py-4 md:py-4.5 lg:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold shadow-2xl transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
          >
            <i className="ri-calendar-check-line text-xl sm:text-2xl md:text-3xl"></i>
            <span>{t('heroCtaBook')}</span>
          </button>
          
          <Link
            to="/pricing"
            className="w-full sm:w-auto bg-white/95 hover:bg-white text-gray-800 px-6 sm:px-8 md:px-10 lg:px-12 py-3.5 sm:py-4 md:py-4.5 lg:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold shadow-2xl transition-all transform hover:scale-105 flex items-center justify-center space-x-2"
          >
            <i className="ri-price-tag-line text-xl sm:text-2xl md:text-3xl text-orange-500"></i>
            <span>{t('heroCtaPricing')}</span>
          </Link>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 text-white/90 px-2 sm:px-4">
          <div className="flex items-center space-x-2">
            <i className="ri-star-fill text-yellow-400 text-xl sm:text-2xl md:text-3xl lg:text-4xl"></i>
            <span className="font-semibold text-xs sm:text-sm md:text-base lg:text-lg">{t('heroTrust1')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-user-heart-line text-xl sm:text-2xl md:text-3xl lg:text-4xl"></i>
            <span className="font-semibold text-xs sm:text-sm md:text-base lg:text-lg">{t('heroTrust2')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-time-line text-xl sm:text-2xl md:text-3xl lg:text-4xl"></i>
            <span className="font-semibold text-xs sm:text-sm md:text-base lg:text-lg">{t('heroTrust3')}</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 md:bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl md:text-4xl drop-shadow-lg"></i>
      </div>
    </section>
  );
}
